var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBacktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 450",
    width: 900,
    height: 450,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 450,
    fill: "#000f16"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 374L11.5 386.2C23 398.3 46 422.7 69 423.2C92 423.7 115 400.3 138.2 400C161.3 399.7 184.7 422.3 207.8 431.5C231 440.7 254 436.3 277 428.7C300 421 323 410 346 408.2C369 406.3 392 413.7 415.2 414.8C438.3 416 461.7 411 484.8 415.5C508 420 531 434 554 433.8C577 433.7 600 419.3 623 416.8C646 414.3 669 423.7 692.2 417.7C715.3 411.7 738.7 390.3 761.8 380.2C785 370 808 371 831 382.2C854 393.3 877 414.7 888.5 425.3L900 436L900 451L888.5 451C877 451 854 451 831 451C808 451 785 451 761.8 451C738.7 451 715.3 451 692.2 451C669 451 646 451 623 451C600 451 577 451 554 451C531 451 508 451 484.8 451C461.7 451 438.3 451 415.2 451C392 451 369 451 346 451C323 451 300 451 277 451C254 451 231 451 207.8 451C184.7 451 161.3 451 138.2 451C115 451 92 451 69 451C46 451 23 451 11.5 451L0 451Z",
    fill: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktop);
export default __webpack_public_path__ + "static/media/backtop.635881533034e820c0b523e84e4691d6.svg";
export { ForwardRef as ReactComponent };